export class Archivado {
  observacion: string;
  instante: Date;
}
